module.exports = "<div class=\"loaderFrame\">\n    <div class=\"loaderContainer\">\n        <div class=\"loader\">\n            <span class=\"dot dot_1\"></span>\n            <span class=\"dot dot_2\"></span>\n            <span class=\"dot dot_3\"></span>\n            <span class=\"dot dot_4\"></span>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/spinner/spinner.component.html
// module id = 970
// module chunks = 0